import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Pipe({
  name: 'remaining',
  standalone: true,
})
export class RemainingPipe implements PipeTransform {
  dayRemaining: string;
  daysRemaining: string;

  constructor(private translateService: TranslateService) {
    this.dayRemaining = this.translateService.instant('+INVITATIONS.INVITATION.DAY_REMAINING');
    this.daysRemaining = this.translateService.instant('+INVITATIONS.INVITATION.DAYS_REMAINING');
  }

  transform(date: string): string {
    const expire = moment(date);
    const diff = expire.diff(moment(), 'days');
    if (diff > 0) {
      return diff === 1
        ? `(${this.dayRemaining})`
        : `(${this.daysRemaining.replace('{{days}}', `${diff}`)})`;
    }

    return '';
  }
}
